import React from 'react';


export const WebContext = React.createContext();